const DB_NAME = 'lexicon_db'
const DB_VERSION = 3
let DB

export default {

  async getDb () {
    return new Promise((resolve, reject) => {
      // if (window.indexedDB) {
      //     console.log("IndexedDB is supported");
      // }

      if (DB) { return resolve(DB) }

      // console.log('OPENING DB', DB);
      let request = window.indexedDB.open(DB_NAME, DB_VERSION)

      request.onerror = e => {
        console.log('Error opening db', e)
        reject('Error')
      }

      request.onsuccess = e => {
        DB = e.target.result
        resolve(DB)
      }

      request.onupgradeneeded = e => {
        console.log('onupgradeneeded')
        let db = e.target.result
        db.createObjectStore('kamus', { autoIncrement: true, keyPath: 'id' })
      }
    })
  },

  async saveKamusAll (datas) {
    let db = await this.getDb()

    return new Promise(resolve => {
      let trans = db.transaction(['kamus'], 'readwrite')
      trans.oncomplete = () => {
        resolve()
      }

      let store = trans.objectStore('kamus')
      datas.forEach(each => {
        store.add(each)
      })
    })
  },

  async getKamusAll () {
    let db = await this.getDb()

    return new Promise(resolve => {
      let trans = db.transaction(['kamus'], 'readonly')
      trans.oncomplete = () => {
        resolve(cats)
      }

      let store = trans.objectStore('kamus')
      let cats = []

      store.openCursor().onsuccess = e => {
        let cursor = e.target.result
        if (cursor) {
          cats.push(cursor.value)
          cursor.continue()
        }
      }
    })
  }

  // async deleteCat(cat) {

  // 	let db = await this.getDb();

  // 	return new Promise(resolve => {

  // 		let trans = db.transaction(['cats'],'readwrite');
  // 		trans.oncomplete = () => {
  // 			resolve();
  // 		};

  // 		let store = trans.objectStore('cats');
  // 		store.delete(cat.id);
  // 	});
  // },

}
